import { IonContent } from '@ionic/react';
import React from 'react';

import { useAccount } from '@/hooks/useAccount';
import { useAppModals } from '@/hooks/useAppModals';
import { webCampaign } from '@/modules/webCampaign';
import { SectionPaymentMethodSelection } from '@/pages/Paywall/sections/PaymentMethodSelection';

import { PaymentModalStyles } from './Payment.styles';

export const PaymentModal: React.FC = () => {
  const { refreshUser } = useAccount();
  const { hide, isVisible } = useAppModals('paywall');

  return (
    <PaymentModalStyles
      key="onboarding-payment"
      id="onboarding-payment"
      role="dialog"
      breakpoints={[0, 1]}
      initialBreakpoint={1}
      isOpen={isVisible}
      onWillDismiss={hide}
      onWillPresent={() => {
        refreshUser();
      }}
      staticTheme={webCampaign.getStaticTheme()}
    >
      <IonContent>
        <SectionPaymentMethodSelection />
      </IonContent>
    </PaymentModalStyles>
  );
};
